/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {UiToolButtonConfig} from "../../generated/UiToolButtonConfig";
import {UiPanel} from "../UiPanel";
import {TeamAppsEvent} from "../util/TeamAppsEvent";
import {UiComponentConfig} from "../../generated/UiComponentConfig";
import {bind} from "../util/Bind";
import {UiComponent} from "../UiComponent";
import {TabPanelItem} from "./TabPanelItem";
import {ViewInfo} from "./ViewInfo";

export class View implements ViewInfo {
	public parent: TabPanelItem;
	public onSpecialToolButtonPressed: TeamAppsEvent<string> = new TeamAppsEvent<string>(this);

	private _component: UiComponent<UiComponentConfig>;

	constructor(public viewName: string,
	            public tabIcon: string,
	            public tabCaption: string,
	            public tabCloseable: boolean,
	            public lazyLoading: boolean,
	            component: UiComponent<UiComponentConfig>) {
		this.component = component;
	}

	public get component() {
		return this._component;
	}

	public set component(component) {
		if (this._component != null && this._component instanceof UiPanel) {
			this._component.onSpecialToolButtonPressed.removeListener(this.specialButtonPressed)
		}
		this._component = component;
		if (this.parent) {
			this.parent.updateTab(this.viewName, this._component);
		}
		if (component != null && component instanceof UiPanel) {
			component.onSpecialToolButtonPressed.addListener(this.specialButtonPressed)
			component.setDraggable(true);
		}
	}

	@bind
	private specialButtonPressed(buttonId: string) {
		this.onSpecialToolButtonPressed.fire(buttonId);
	}

	updateTabAttributes(tabIcon: string, tabCaption: string, tabCloseable: boolean) {
		this.tabIcon = tabIcon;
		this.tabCaption = tabCaption;
		this.tabCloseable = tabCloseable;
		this.parent.setTabConfiguration(this.viewName, tabIcon, tabCaption, tabCloseable);
	}

	public get viewInfo(): ViewInfo {
		return {
			viewName: this.viewName,
			tabIcon: this.tabIcon,
			tabCaption: this.tabCaption,
			tabCloseable: this.tabCloseable
		};
	}

	setSpecialToolButtons(toolButtonConfigs: UiToolButtonConfig[]) {
		if (this.component instanceof UiPanel) {
			(this.component as UiPanel).setSpecialToolButtons(toolButtonConfigs);
		}
	}
}